import { System, SystemImpl } from 'minecs';
import type { GameModel } from 'yage/game/GameModel';
import { AirportState, AirportPilot, AirportPlane, AirportPassenger } from '../components/index.js';
import { CREW } from '../domain/config.js';
import { departurePoint } from '../domain/gateflow.js';
import { tier } from '../domain/airports.js';
import { ROUTES } from '../domain/operations.js';
import { state, ids, route } from '../services/world.js';
import { planes, routes } from '../services/operations.js';
@System(AirportState)
export class AirportDemand extends SystemImpl<GameModel> {
    static depth = 1050;
    run = (g: GameModel) => {
        if (!state(g).loaded) return;
        for (const r of routes(g)) {
            if (!r.unlocked) continue;
            const config = ROUTES[r.index];
            if (r.demand >= config.seats * 3) { r.demandClock = 0; continue; }
            if (++r.demandClock >= config.demandFrames) { r.demandClock = 0; r.demand++; }
        }
        for (const p of planes(g)) {
            if (p.plannedRoute < 0 || p.phase !== 0 || p.boarded !== 0) continue;
            if (ids(g, AirportPassenger).some(id => { const q = g.getTypedUnsafe(AirportPassenger, id); return q.state === 3 && q.gate === p.gate; })) continue;
            p.visiting = false; p.routeIndex = p.plannedRoute; p.scheduleFrames = p.plannedSchedule;
            p.seats = ROUTES[p.routeIndex].seats; p.tripFrames = ROUTES[p.routeIndex].flightFrames;
            p.nextDepartureFrame = g.frame + p.scheduleFrames; p.plannedRoute = -1;
        }
    };
}
@System(AirportPilot)
export class AirportPilotRouting extends SystemImpl<GameModel> {
    static depth = 1550;
    run = (g: GameModel, id: number) => {
        if (!state(g).loaded) return;
        const pilot = g.getTypedUnsafe(AirportPilot, id);
        if (pilot.flyingGate >= 0) return;
        const plane = planes(g).find(p => p.gate === pilot.assignedGate);
        route(g, id, plane ? departurePoint(tier(state(g)).code, plane.gate) : { x: CREW.x + pilot.index * 24, y: CREW.y });
    };
}
